import React from "react";
import "./InputField.css";

const InputField = ({ label, placeholder, ...props }) => {
  return (
    <div className="input-container">
      {label && <label className="input-label">{label}</label>}
      <input className="input-field" placeholder={placeholder} {...props} />
    </div>
  );
};

export default InputField;
